<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/zhoukan">盛京医讯</router-link>
    </div>

    <div class="container-width yixun mt50">
      <div class="l-img">
        <div class="block z-fm">
          <img :src="column.img" />
          <p>01:封面</p>
        </div>
        <div class="block download">
          <p>离线下载电子报<i class="iconfont icon-xiazai"></i></p>
        </div>
        <div class="block calendar">
          <div class="calendar-title">按日期查阅</div>

          <div class="select-time">
            <img :src="d1" @click="minusYear(true)" />
            <select
              class="jumpmenu"
              v-model="current.year"
              @change="changeYear($event)"
            >
              <option
                v-for="(options, id) in selectYearData"
                :key="id"
                :value="options.id"
              >
                {{ options.title }}年
              </option>
            </select>
            <img
              :src="d"
              width="7"
              height="11"
              style="cursor: hand; margin-right: 5px"
              @click="plusYear(true)"
            />
            <img
              :src="d1"
              width="7"
              height="11"
              style="cursor: hand; margin-left: 5px"
              @click="minusMonth(ture)"
            />

            <select
              class="jumpmenu"
              v-model="current.month"
              @change="changeMounth($event)"
            >
              <option
                v-for="(options, id) in selectMounthData"
                :key="id"
                :value="options.id"
              >
                {{ options.title }}月
              </option>
            </select>

            <img
              :src="d"
              width="7"
              height="11"
              style="cursor: hand; margin-right: 5px"
              @click="plusMonth(true)"
            />
          </div>

          <div class="calendar-card">
            <div class="calendar-content">
              <ul class="ul-week">
                <li class="li-week" v-for="(item, m) in week" :key="m">
                  <b>{{ item }}</b>
                </li>
              </ul>
              <ul class="ul-day">
                <li
                  class="li-day"
                  v-for="(item, n) in days"
                  :key="n"
                  :isThisMonth="item.isThisMonth"
                  @click="handleClick(item)"
                >
                  <span v-if="item.isThisMonth != 1">{{ item.date }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="r-list">
        <ul>
          <li class="li-item" style="background-color: #00479d; color: #fff">
            <span>版面目录</span>
            <span>《 {{ currentContent.releaseDate }}出版 》</span>
          </li>

          <li
            @click="goArticle(item)"
            v-for="(item, index) in list"
            :key="index"
            class="li-item"
          >
            <span class="title">{{ item.title }}</span
            ><span class="date">【{{ item.releaseDate }}】</span>
          </li>
          <li class="cycle">
            <span @click="goPrePeriod()">上一期</span
            ><span @click="goNextPeriod()">下一期</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- <div class="container">
    <img
      :src="column.img"
      border="0"
      usemap="#PagePicMap"
      style="display: inline; width: 350px; height: 496px"
    />
   
    <tr v-for="(item, index) in list" :key="index" @click="goArticle(item)">
      <td class="default" align="left">
        &nbsp;{{ item.num }}：{{ item.title }}
      </td>
    </tr>
  </div> -->
</template>
<script>
import service from "../../service/sjwh";
import config from "../../config/dev";
import BANNER from "../../components/banner/sjwh";
export default {
  name: "ZHOUKANLIST",
  data() {
    return {
      navigationData: [
      {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        {
          name: "盛京医讯",
          path: "/sjwh/zhoukan",
          width: "33%",
        },
        {
          name: "盛京TV",
          path: "/sjwh/tv",
        },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh/zhoukan",
      list: [],
      beforeContent: {}, // 上一篇内容
      afterContent: {}, // 下一篇内容
      currentContent: {},
      pageIndex: 1,
      pageSize: 8,
      totalPages: 1,
      currentPage: 1,
      total: 0,
      picUrl: "",
      image04: require("../../assets/image/image04.jpg"),
      image03: require("../../assets/image/image03.jpg"),
      image01: require("../../assets/image/image01.jpg"),
      image02: require("../../assets/image/image02.jpg"),
      image06: require("../../assets/image/image06.jpg"),

      nowDate: "", // 当前日期
      nowTime: "", // 当前时间
      nowWeek: "", // 当前星期
      column: {}, // 当前栏目
      // 日历
      date: {
        year: "",
        month: "",
        date: "",
      },
      current: {
        year: "",
        month: "",
        date: "",
      },
      week: ["日", "一", "二", "三", "四", "五", "六"],
      days: [],
      dateList: [],
      // currentMounth: "",
      selectYearData: [
        { id: 2010, title: "2010" },
        { id: 2011, title: "2011" },
        { id: 2012, title: "2012" },
        { id: 2013, title: "2013" },
        { id: 2014, title: "2014" },
        { id: 2015, title: "2015" },
        { id: 2016, title: "2016" },
        { id: 2017, title: "2017" },
        { id: 2018, title: "2018" },
        { id: 2019, title: "2019" },
        { id: 2020, title: "2020" },
        { id: 2021, title: "2021" },
        { id: 2022, title: "2022" },
        { id: 2023, title: "2023" },
        { id: 2024, title: "2024" },
        { id: 2025, title: "2025" },
        { id: 2026, title: "2026" },
        { id: 2027, title: "2027" },
        { id: 2028, title: "2028" },
        { id: 2029, title: "2029" },
        { id: 2030, title: "2030" },
        { id: 2031, title: "2031" },
        { id: 2032, title: "2032" },
        { id: 2033, title: "2033" },
      ],
      selectMounthData: [
        { id: 1, title: "1" },
        { id: 2, title: "2" },
        { id: 3, title: "3" },
        { id: 4, title: "4" },
        { id: 5, title: "5" },
        { id: 6, title: "6" },
        { id: 7, title: "7" },
        { id: 8, title: "8" },
        { id: 9, title: "9" },
        { id: 10, title: "10" },
        { id: 11, title: "11" },
        { id: 12, title: "12" },
      ],
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    let id = this.$route.query.id;
    this.init(id);
  },
  beforeMount() {},
  methods: {
    init(id) {
      let parmes = {
        medicalinfoId: id,
        pageIndex: 1,
        pageSize: 200,
        isshow: "1",
      };
      service.getInfo(
        {
          id: id,
        },
        (res) => {
          if (res.current) {
            res.current.img =
              config.url +
              "/file/downloadFile/" +
              res.current.img +
              "?isDownload=true";
          }

          this.beforeContent = res.before ? { ...res.before } : "";
          this.column = { ...res.current };
          this.afterContent = res.after ? { ...res.after } : "";
        }
      );
      service.getwzSjMedicalInformationMenuList(parmes, (res) => {
        if (res.content.length) {
          // res.content.map((item) => {
          //   item.releaseDate = item.releaseDate
          //   item.img =
          //     config.url +
          //     "/file/downloadFile/" +
          //     item.img +
          //     "?isDownload=true";
          // });
          this.list = res.content || [];
          this.currentContent = { ...res.content[0] };
          this.total = res.totalElements;
          this.totalPages = parseInt(res.totalPages) || 0;
          this.currentMounth = res.content[0].releaseDate.substring(0, 7);
        }
        this.checknumbers();
      });
    },
    goArticle(e) {
      let articleId = e.id;
      if (e.url && e.url.length) {
        window.open(e.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: "/sjwh/zhoukan/article/",
          query: {
            id: `${articleId}`,
            medicalinfoId: e.medicalinfoId,
            num: e.num,
          },
        });
        window.open(href, "_self");
      }
    },
    dealWithTime(data) {
      // 获取当前时间
      let formatDateTime;
      let Y = data.getFullYear();
      let M = data.getMonth() + 1;
      let D = data.getDate();
      let H = data.getHours();
      let Min = data.getMinutes();
      let S = data.getSeconds();
      let W = data.getDay();
      H = H < 10 ? "0" + H : H;
      Min = Min < 10 ? "0" + Min : Min;
      S = S < 10 ? "0" + S : S;
      switch (W) {
        case 0:
          W = "日";
          break;
        case 1:
          W = "一";
          break;
        case 2:
          W = "二";
          break;
        case 3:
          W = "三";
          break;
        case 4:
          W = "四";
          break;
        case 5:
          W = "五";
          break;
        case 6:
          W = "六";
          break;
        default:
          break;
      }
      this.nowDate = Y + "年" + M + "月" + D + "日 ";
      this.nowWeek = "星期" + W;
      this.nowTime = H + ":" + Min + ":" + S;
      // formatDateTime = Y + "年" + M + "月" + D + "日 " + " 周" +W + H + ":" + Min + ":" + S;
    },
    goPrePeriod() {
      if (this.beforeContent) {
        if (this.beforeContent.url) {
          window.open(this.beforeContent.url, "_self");
        } else {
          const { href } = this.$router.resolve({
            path: `/sjwh/zhoukan/list`,
            query: {
              id: this.beforeContent.id,
            },
          });
          window.open(href, "_self");
        }
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    goNextPeriod() {
      if (this.afterContent) {
        if (this.afterContent.url) {
          window.open(this.afterContent.url, "_self");
        } else {
          const { href } = this.$router.resolve({
            path: `/sjwh/zhoukan/list`,
            query: {
              id: this.afterContent.id,
            },
          });
          window.open(href, "_self");
        }
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    plusMonth: function () {
      if (this.date.month == 11) {
        this.date.month = 0;
        this.current.month = 1;
        this.plusYear(false);
      } else {
        this.date.month++;
        this.current.month++;
      }
      this.currentMounth =
        this.date.year +
        "-" +
        (this.date.month < 10
          ? "0" + (this.date.month + 1)
          : this.date.month + 1);

      this.createCalendar(this.date.year, this.date.month);
      this.checknumbers();
    },
    minusMonth: function () {
      if (this.date.month == 0) {
        this.date.month = 11;
        this.current.month = 12;
        this.minusYear(false);
      } else {
        this.date.month--;
        this.current.month--;
      }
      this.currentMounth =
        this.date.year +
        "-" +
        (this.date.month < 10
          ? "0" + (this.date.month + 1)
          : this.date.month + 1);

      this.createCalendar(this.date.year, this.date.month);
      this.checknumbers();
    },
    plusYear: function (create) {
      if (this.date.year == 2049) {
        this.date.year = 1970;
      } else {
        this.date.year++;
        this.current.year++;
      }
      if (create) {
        this.currentMounth =
          this.date.year +
          "-" +
          (this.date.month < 10
            ? "0" + (this.date.month + 1)
            : this.date.month + 1);

        this.createCalendar(this.date.year, this.date.month);
        this.checknumbers();
      }
    },
    minusYear: function (create) {
      if (this.date.year == 1970) {
        this.date.year = 2049;
      } else {
        this.date.year--;
        this.current.year--;
      }
      if (create) {
        this.currentMounth =
          this.date.year +
          "-" +
          (this.date.month < 10
            ? "0" + (this.date.month + 1)
            : this.date.month + 1);

        this.createCalendar(this.date.year, this.date.month);
        this.checknumbers();
      }
    },
    createCalendar: function (year, month) {
      this.days = [];
      let d = new Date();
      d.setFullYear(year);
      d.setMonth(month);
      d.setDate(1);
      let dayOfFirstDay = d.getDay();
      for (let i = 0; i < 42; i++) {
        d.setDate(1);
        d.setMonth(month);
        d.setDate(i - dayOfFirstDay + 1);

        let isThisMonth = 1;
        if (d.getMonth() == month) {
          isThisMonth = 2;
        } else {
          isThisMonth = 1;
        }

        let date = {
          year: d.getFullYear(),
          month: d.getMonth(),
          date: d.getDate(),
          isThisMonth: isThisMonth,
        };

        this.days.push(date);
        this.days.map((item) => {
          if (item.month < 10) {
            item.trueMounth = "0" + (item.month + 1);
          } else {
            item.trueMounth = item.month + 1;
          }
          if (item.date < 10) {
            item.trueDate = "0" + item.date;
          } else {
            item.trueDate = item.date;
          }

          let checkDate =
            item.year + "-" + item.trueMounth + "-" + item.trueDate;

          this.dateList.map((m) => {
            if (m.time == checkDate) {
              item.isThisMonth = 3;
              item.url = m.url ? m.url : "";
              item.id = m.id;
            }
          });
        });
      }
    },
    checknumbers() {
      let parmes = {
        pageIndex: 1,
        pageSize: window.screen.width < 720 ? 6 : 10,
        date: this.currentMounth,
      };
      this.dateList = [];
      service.getwzSjMedicalInformationList(parmes, (res) => {
        res.content.map((item) => {
          item.time = item.releaseDate.split(" ")[0];
        });
        this.dateList = res.content;
        this.createCalendar(this.date.year, this.date.month);
      });
    },
    handleClick(e) {
      if (e.url) {
        window.open(e.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: `/sjwh/zhoukan/list`,
          query: {
            id: e.id,
          },
        });
        window.open(href, "_blank");
      }
    },
    changeYear(event) {
      this.current.year = event.target.value;
      this.date.year = event.target.value;
      this.currentMounth =
        this.date.year +
        "-" +
        (this.date.month < 10
          ? "0" + (this.date.month + 1)
          : this.date.month + 1);
      this.createCalendar(this.date.year, this.date.month);
      this.checknumbers();
    },
    changeMounth(event) {
      this.current.month = event.target.value;
      this.date.month = event.target.value - 1;
      this.currentMounth =
        this.date.year +
        "-" +
        (this.date.month < 10
          ? "0" + (this.date.month + 1)
          : this.date.month + 1);
      this.createCalendar(this.date.year, this.date.month);
      this.checknumbers();
    },
  },
  mounted() {
    this.dealWithTime(new Date());
    // 日历
    let d = new Date();
    this.date.year = d.getFullYear();
    this.date.month = d.getMonth();
    this.date.date = d.getDate();

    this.current.year = d.getFullYear();
    this.current.month = d.getMonth() + 1;
    this.current.date = d.getDate();
  },
  watch: {},
};
</script>


<style scoped lang="scss">
body,
td,
th,
prelink {
  font-size: 12px;
}
a {
  color: #000;
}

.STYLE30 {
  color: #001e50;
  font-weight: bold;
}

.commonlight2 {
  background-color: #a2dbff;
}

.commoncolor3 {
  background-color: #ffffff;
}
.container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #ffffff;
  width: 100%;
}

#bmdhTable tr {
  height: 25px;
  cursor: pointer;
}
// 日历

.calendar-bar {
  height: 40px;
  color: #727272;
  line-height: 40px;
  text-align: center;
  /* background-color: #ebeef5; */
}

.calendar-date {
  display: inline-block;
  width: 100px;
}

.button {
  width: 20px;
  height: 20px;
  background-color: #fff;
  color: #aaa;
  border: 0;
  border-radius: 5px;
}

.button:hover {
  background-color: #eee;
  cursor: pointer;
}

.li-day:hover {
  // background-color: #717de2;
  // color: #fff;
  // font-size: 15px;
}

.jumpmenu {
  font-size: 13.3px;
  color: #000;
}
.cycle {
  height: 80px;
  line-height: 80px;
  padding: 0 30px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-end;
  span {
    font-size: 1.3rem;
    margin-left: 20px;
    cursor: pointer;
  }
}
.yixun {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;

  margin-bottom: 50px;
  .l-img {
    width: 280px;
    p {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 1.2rem;
    }
  }
  .r-list {
    width: calc(100% - 310px);
    ul {
      border: 1px solid #ebebeb;
      margin-bottom: 50px;
      .li-item {
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebebeb;
        padding: 0 30px;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
      li-item:last-child {
        border-bottom: none;
      }
    }
  }
  .block {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
  }
  .z-fm {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.3);
    position: relative;
    img {
      width: 280px;
      height: 396.8px;
    }
    p {
      position: absolute;
      width: 160px;
      height: 35px;
      line-height: 35px;
      left: 60px;
      bottom: 15px;
      border: 1px solid #fff;
      color: #fff;
    }
  }
  .download {
    height: 120px;
    width: 100%;
    cursor: pointer;
    margin-top: 30px;
    p {
      display: block;
      width: 100%;
      height: 100%;
      background: #00479d;
      color: #fff;
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: center;
      justify-content: center;

      -webkit-box-align: center;
      align-items: center;
      font-size: 1.4rem;
      letter-spacing: 3px;
      i {
        font-size: 1.4rem;
        margin-right: 5px;
        margin-top: 3px;
        display: inline-block;
      }
    }
  }
  .pagination {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
.calendar-title {
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: #00479d;
  text-align: center;
}
.select-time {
  height: 40px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 10px;
}
.calendar {
  margin-top: 30px;
}
.calendar-card {
  border: 1px solid #ebeef5;
  height: auto;
  .ul-week {
    display: grid;
    width: 280px;
    grid-template-rows: 20px;
    grid-template-columns: repeat(7, 1fr); /**/
    list-style: none;
    text-align: center;
    font-size: 13px;
    color: #aaa;
    padding-inline-start: 0px;
    padding-inline-end: 0px;
    border-bottom: 1px solid #eee;
    height: 30px;
    line-height: 30px;
    .li-week {
      display: inline-block;
      background: #e8e8e8;
      margin-right: 1px;
      color: #000;
      height: 30px;
    }
  }

  .ul-day {
    display: grid;
    width: 280px;
    grid-template-rows: repeat(6, 1fr);
    grid-template-columns: repeat(7, 1fr);
    list-style: none;
    text-align: center;
    height: 192px;

    .li-day {
      display: inline-block;
      font-size: 0.8rem;
      line-height: 30px;
      text-align: center;
      margin: 1px;
      color: #999;
      background: #e6effc;
      height: 30px;
    }

    .li-day[isThisMonth="3"] {
      font-size: 0.9rem;
      color: #842331;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
